import initialState from '../store/initialState'
import auth_types from '../constants/authTypes'

export default function authReducer(state = initialState.auth, action) {
  switch (action.type) {

    case auth_types.set_current_user: {
      return {
        ...state,
        current_user: {
          ...state.current_user,
          data: action.payload,
          errors: []
        }
      }
    }

    case auth_types.CONFIRM.request: {
      return {
        ...state,
        isConfirming: true,
        confirmed: false,
        requiresPassword: false,
        passToken: undefined,
        errors:[],
      }
    }

    case auth_types.CONFIRM.success: {
      return {
        ...state,
        isConfirming: false,
        confirmed: true,
        requiresPassword: (action.payload && action.payload.reset_pass_token) ? true : false ,
        passToken: action.payload ? action.payload.reset_pass_token : undefined,
      }
    }

    case auth_types.CONFIRM.failure: {
      return {
        ...state,
        isConfirming: false,
        confirmed: false,
        errors: action.payload
      }
    }

    case auth_types.VALIDATE_TOKEN.request:
      return {
        ...state,
        tokenInvalid: false,
        isValidating: true,
        current_user: {
          ...state.current_user,
          errors: []
        }
      };

    case auth_types.VALIDATE_TOKEN.success:
      // JSON.parse(localStorage.getItem('userdata'))
      return {
        ...state,
        isValidating: false,
        isAuthenticated: true,
        tokenInvalid: false,
        current_user: {
          ...state.current_user,
          data: action.payload.data,
          errors: [],
          headers: {
            "token": action.payload.headers['X-User-Token'],
            "email": action.payload.headers['X-User-Email']
          }
        }
      };

    case auth_types.VALIDATE_TOKEN.failure:
      if (action.payload === false) {
        return {
          ...state,
          isValidating: false,
          isAuthenticated: false,
          tokenInvalid: false,
          current_user: {
            ...state.current_user,
            data: {},
            errors: []
          }
        }
      } else {
        return {
          ...state,
          isValidating: false,
          isAuthenticated: false,
          tokenInvalid: true,
          current_user: {
            ...state.current_user,
            data: {},
            errors: action.payload
          }
        }
      }

    case auth_types.LOGOUT.request:
      return {
        ...state,
        isSubmitting: true,
        isLoggingOut: true,
        current_user: {
          ...state.current_user,
          errors: []
        }
      }

    case auth_types.LOGOUT.success:
    return {
      ...state,
      isLoggingOut: false,
      isSubmitting: false,
      isAuthenticated: false,
      current_user: {
        ...state.current_user,
        data: {},
        errors: []
      }
    }

    case auth_types.LOGOUT.force:
      if (state.isAuthenticated) {
        // window.M.toast({html: "The server has terminated your session"})
        return {
          ...state,
          isAuthenticated: false,
          current_user: {
            ...state.current_user,
            data: {},
            headers: {},
            errors: []
          }
        }
      } else {
        return {
          ...state
        }
      }

    case auth_types.LOGOUT.failure:
      return {
        ...state,
        isLoggingOut: false,
        isSubmitting: false,
        current_user: {
          ...state.auth.current_user,
          errors: action.payload
        }
      }


    case auth_types.LOGIN.request:
      return {
        ...state,
        isLoggingIn: true,
        isSubmitting: true,
        failedLogin: false,
        isAuthenticated: false,
        current_user: {
          ...state.current_user,
          errors: []
        }
      }

    case auth_types.LOGIN.success:
      return {
        ...state,
        isLoggingIn: false,
        isSubmitting: false,
        isAuthenticated: true,
        current_user: {
          ...state.current_user,
          data: action.payload.data,
          headers: {
            "token": action.payload.headers['X-User-Token'],
            "email": action.payload.headers['X-User-Email']
          }
        }
      }

    case auth_types.LOGIN.failure:
      return {
        ...state,
        isLoggingIn: false,
        isSubmitting: false,
        isAuthenticated: false,
        failedLogin: true,
        current_user: {
          ...state.current_user,
          errors: action.payload
        }
      }

    case auth_types.REQUEST_PASSWORD.request: {
      return {
        ...state,
        isSubmitting: true,
        resetSent: false
      }
    }

    case auth_types.REQUEST_PASSWORD.success: {
      return {
        ...state,
        isSubmitting: false,
        resetSent: true,
        current_user: {
          ...state.current_user,
          errors: []
        }
      }
    }

    case auth_types.REQUEST_PASSWORD.failure: {
      return {
        ...state,
        isSubmitting: false,
        resetSent: false,
        current_user: {
          ...state.current_user,
          errors: action.payload
        }
      }
    }

    case auth_types.REQUEST_PASSWORD.reset: {
      return {
        ...state,
        isSubmitting: false,
        resetSent: false,
        current_user: {
          ...state.current_user,
          errors: []
        }
      }
    }

  ////////
  case auth_types.RESET_PASSWORD.request: {
    return {
      ...state,
      resetSuccessful: false,
      isSubmitting: true
    }
  }

  case auth_types.RESET_PASSWORD.success: {
    return {
      ...state,
      isSubmitting: false,
      resetSuccessful: true,
      current_user: {
        ...state.current_user,
        errors: []
      }
    }
  }

  case auth_types.RESET_PASSWORD.failure: {
    return {
      ...state,
      isSubmitting: false,
      resetSuccessful: false,
      current_user: {
        ...state.current_user,
        errors: action.payload
      }
    }
  }

  case auth_types.RESET_PASSWORD.reset: {
    return {
      ...state,
      isSubmitting: false,
      resetSuccessful: false,
      current_user: {
        ...state.current_user,
        errors: []
      }
    }
  }

  case auth_types.RESET_PASSWORD.error: {
    return {
      ...state,
      current_user: {
        ...state.current_user,
        errors: action.payload
      }
    }
  }

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/js/reducers/authReducer.js